module.exports = __webpack_public_path__ + "img/H03102-01.074b24e6.jpg";